import React from "react";
import "./CourseLesson.css";
import { UserAuth } from "../context/AuthContext";
import LockIcon from "@mui/icons-material/Lock";

const EasyJS = () => {
  const { userIsPremium } = UserAuth();
  return (
    <div className="course__lesson">
       <div className="section__box technical__color">
        <h1 className="section__title">Section 8: Technical</h1>
      </div>
      <h1 className="lesson__title">Easy JavaScript Challenges</h1>
      <p className="lesson__para">
        Get your JavaScript skills warmed up with some easy challenges you may face in a technical interview.
      </p>
      <div className="video__frame technical">
        {userIsPremium && (
          <iframe
          className="video"
            width="600"
            height="600"
            src="https://www.youtube.com/embed/587ZKWCifDg"
            title="YouTube video player"
            frameborder="0"
            allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        )}
        {!userIsPremium && (
          <div className="video">
            <img
              className="video"
              src="https://i.ytimg.com/vi/tNJQY1tP5mY/maxresdefault.jpg"
              alt=""
            />
            <LockIcon className="lock pre" />
            <h2 className="lock__text">
            Upgrade to a <span className="pre">Premium</span> account to access this content
            </h2>
          </div>
        )}
      </div>
      <div className="buttons__container">
        <a className="btn__wrapper" href="/section-8/lesson-2">
          <button className="technical__btn next__lesson--btn">
            Proceed to Lesson 2
          </button>
        </a>
        <a
          className="btn__wrapper"
          target="_blank"
          href="https://discord.gg/P8hxsbzsKS"
        >
          <button className="help__btn next__lesson--btn">Need Help?</button>
        </a>
      </div>
    </div>
  );
};

export default EasyJS;
